import React from 'react'
import { ConfirmationModalMetaProps } from '../data/types'
import { Button } from './ui/Button'
import { Modal } from './ui/Modal'
import { WarningIcon } from '../icons'

type Props = {
    meta: ConfirmationModalMetaProps
    isOpen: boolean
    onConfirm: () => void
    onCancel: () => void
    title: string
    message: string
    isLoading?: boolean
    confirmButtonColor?: 'primary' | 'danger' | 'success' | 'warn'
    confirmButtonText?: string
    loadingButtonText?: string
}

export const ConfirmationModal = (props: Props) => {
    const {
        meta,
        isOpen,
        onConfirm,
        onCancel,
        title,
        message,
        isLoading = false,
        confirmButtonColor = 'danger',
        confirmButtonText,
        loadingButtonText
    } = props

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            title={title}
            showCloseButton={false}
            icon={
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-100 dark:bg-danger-900">
                    <WarningIcon className="h-6 w-6 text-danger-600 dark:text-danger-400" />
                </div>
            }
            footer={
                <div className="flex flex-row-reverse gap-3">
                    <Button
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                        color={confirmButtonColor}
                    >
                        {isLoading ? (loadingButtonText || meta.deletingButton) : (confirmButtonText || meta.confirmButton)}
                    </Button>
                    <Button
                        type="button"
                        onClick={onCancel}
                        disabled={isLoading}
                        variant="outline"
                        color="neutral"
                    >
                        {meta.cancelButton}
                    </Button>
                </div>
            }
        >
            <div className="px-6 py-4">
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    {message}
                </p>
            </div>
        </Modal>
    )
}
